import { render, staticRenderFns } from "./ResetPasswordStaffModal.vue?vue&type=template&id=653d2ebb&scoped=true&"
import script from "./ResetPasswordStaffModal.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordStaffModal.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordStaffModal.vue?vue&type=style&index=0&id=653d2ebb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d2ebb",
  null
  
)

export default component.exports